import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.update-smtp-mandant-options';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationUpdateSmtpMandantOptionsEffects {

    UpdateSmtpMandantOptions$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_UPDATE_SMTP_MANDANT_OPTIONS),
        mergeMap((x: ac.PostUpdateSmtpMandantOptionsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postUpdateSmtpMandantOptions(x.smtpMandantOptions).pipe(
                map((result: any) => {
                    return new ac.PostUpdateSmtpMandantOptionsErfolgreichAction(x.smtpMandantOptions, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostUpdateSmtpMandantOptionsFehlerAction(error, x.smtpMandantOptions, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.TroubleTicketCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.TroubleTicketCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.TroubleTicketCommandService);
        }
        return this.service;
    }
}
